import { AtlSelectOption } from '../forms/select';

export class AtlExpandingSearchKeyDownEvent extends CustomEvent<{
   payload: string;
}> {
   static EVENT_NAME = 'search-onkeydown';

   constructor(value: string) {
      super(AtlExpandingSearchKeyDownEvent.EVENT_NAME, {
         detail: { payload: value },
         bubbles: true,
         composed: true,
      });
   }
}

export class AtlExpandingSearchChangeEvent extends CustomEvent<{
   payload: AtlSelectOption | undefined;
}> {
   static EVENT_NAME = 'search-onchange';

   constructor(value: AtlSelectOption | undefined) {
      super(AtlExpandingSearchChangeEvent.EVENT_NAME, {
         detail: { payload: value },
         bubbles: true,
         composed: true,
      });
   }
}
